export default "__VITE_ASSET__JGwmqedd__"